import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    introduction: {
        auxiliary: {},
    },
    'function-suitability': {
        auxiliary: {},
    },
    'get-started': {
        auxiliary: {},
    },
    'name-and-personal-details': {
        auxiliary: {
            addtForms: [],
        },
    },
    'contact-information': {
        auxiliary: {
            checked: false,
            mailing_location: true,
            practice_location: true,
            satellite_location: false,
        },
    },
    'special-testing-accommodations': {
        auxiliary: {},
    },
    'applicant-background': {
        auxiliary: {},
    },
    'other-state-licenses': {
        auxiliary: {
            addtForms: [],
        },
    },
    'availability-for-disaster': {
        auxiliary: {},
    },
    'education-history': {
        auxiliary: {
            addtForms: [],
        },
    },
    'practical-nurse-equivalency': {
        auxiliary: {},
    },
    'non-us-graduates': {
        auxiliary: {},
    },
    'examination-history': {
        auxiliary: {
            addtForms: [],
        },
    },
    'health-history': {
        auxiliary: {},
    },
    'discipline-history': {
        denied: {
            auxiliary: {
                addtForms: [],
            },
        },
        action: {
            auxiliary: {
                addtForms: [],
            },
        },
        surrendered: {
            auxiliary: {
                addtForms: [],
            },
        },
        pending: {
            auxiliary: {
                addtForms: [],
            },
        },
    },
    'criminal-history': {
        auxiliary: {
            addtForms: [],
        },
    },
    'sealed-criminal-history': {
        auxiliary: {
            addtForms: [],
        },
    },
    'criminal-and-medicaid-medicare-fraud-questions': {
        auxiliary: {},
    },
    'electronic-fingerprinting': { auxiliary: {} },
    'florida-center-for-nursing': { auxiliary: {} },
    'nurse-licensure-compact': { auxiliary: {} },
    'military-fee-waiver': { auxiliary: {} },
    'file-attachments': {
        values: {},
        auxiliary: {
            dataTableHeaders: [
                {
                    key: 'document_type',
                    header: 'Document Type',
                },
                {
                    key: 'document_name',
                    header: 'Document Name',
                },
                {
                    key: 'remove_file',
                    header: 'Remove File',
                },
            ],
            dataTableRows: [],
            loaded_files: [],
            loaded_files_metadata: [],
            forms_with_files: [],
            uploaded_file_types: [],
            uploaded_file_names: [],
            system_uploaded_file_names: [],
        },
    },
    attestation: {
        auxiliary: {},
    },
    'summary-submission-form': { auxiliary: {} },
}

export const formSlice = createSlice({
    name: 'forms',
    initialState,
    reducers: {
        createFormData: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['values']
                ) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        values: action?.payload?.values,
                    }
                }
            }
        },
        createFormValidity: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['errors']
                ) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload.digital_name],
                        errors: action?.payload?.errors,
                    }
                }
            }
        },
        createFormAuxiliary: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['auxiliary']
                ) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        auxiliary: action?.payload?.auxiliary,
                    }
                }
            }
        },
        updateFormData: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['values']
                ) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        values: {
                            ...state?.[action?.payload?.digital_name]?.values,
                            ...action?.payload?.values,
                        },
                    }
                }
            }
        },
        updateFormValidity: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['errors']
                ) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        errors: {
                            ...state?.[action?.payload?.digital_name]?.errors,
                            ...action?.payload?.errors,
                        },
                    }
                }
            }
        },
        updateFormAuxiliary: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['auxiliary']
                ) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        auxiliary: {
                            ...state?.[action?.payload?.digital_name]
                                ?.auxiliary,
                            ...action?.payload?.auxiliary,
                        },
                    }
                }
            }
        },
        deleteFormData: (state, action) => {
            if (action?.payload) {
                if (action?.['payload']?.['digital_name']) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        values: {},
                    }
                }
            }
        },
        deleteFormValidity: (state, action) => {
            if (action?.payload) {
                if (action?.['payload']?.['digital_name']) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        errors: {},
                    }
                }
            }
        },
        deleteFormAuxiliary: (state, action) => {
            if (action?.payload) {
                if (action?.['payload']?.['digital_name']) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        auxiliary: {},
                    }
                }
            }
        },
        createSubFormData: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['digital_sub_name'] &&
                    action?.['payload']?.['values']
                ) {
                    const curr = action?.payload?.digital_name
                    const currSub = action?.payload?.digital_sub_name
                    const currData = state?.[curr]
                    const currSubData = state?.[curr]?.[currSub]
                    state[action?.payload?.digital_name] = {
                        ...currData,
                        [action?.payload?.digital_sub_name]: {
                            ...currSubData,
                            values: action?.payload?.values,
                        },
                    }
                }
            }
        },
        createSubFormValidity: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['digital_sub_name'] &&
                    action?.['payload']?.['errors']
                ) {
                    const curr = action?.payload?.digital_name
                    const currSub = action?.payload?.digital_sub_name
                    const currData = state?.[curr]
                    const currSubData = state?.[curr]?.[currSub]
                    state[action?.payload?.digital_name] = {
                        ...currData,
                        [action?.payload?.digital_sub_name]: {
                            ...currSubData,
                            errors: action?.payload?.errors,
                        },
                    }
                }
            }
        },
        createSubFormAuxiliary: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['digital_sub_name'] &&
                    action?.['payload']?.['auxiliary']
                ) {
                    const curr = action?.payload?.digital_name
                    const currSub = action?.payload?.digital_sub_name
                    const currData = state?.[curr]
                    const currSubData = state?.[curr]?.[currSub]
                    state[action?.payload?.digital_name] = {
                        ...currData,
                        [action?.payload?.digital_sub_name]: {
                            ...currSubData,
                            auxiliary: action?.payload?.auxiliary,
                        },
                    }
                }
            }
        },
        updateSubFormData: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['digital_sub_name'] &&
                    action?.['payload']?.['values']
                ) {
                    const curr = action?.payload?.digital_name
                    const currSub = action?.payload?.digital_sub_name
                    const currData = state?.[curr]
                    const currSubData = state?.[curr]?.[currSub]
                    const currSubVal = state?.[curr]?.[currSub]['values']
                    state[action?.payload?.digital_name] = {
                        ...currData,
                        [action?.payload?.digital_sub_name]: {
                            ...currSubData,
                            values: {
                                ...currSubVal,
                                ...action?.payload?.values,
                            },
                        },
                    }
                }
            }
        },
        updateSubFormValidity: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['digital_sub_name'] &&
                    action?.['payload']?.['errors']
                ) {
                    const curr = action?.payload?.digital_name
                    const currSub = action?.payload?.digital_sub_name
                    const currData = state?.[curr]
                    const currSubData = state?.[curr]?.[currSub]
                    const currSubVal = state?.[curr]?.[currSub]?.['errors']
                    state[action?.payload?.digital_name] = {
                        ...currData,
                        [action?.payload?.digital_sub_name]: {
                            ...currSubData,
                            errors: {
                                ...currSubVal,
                                ...action?.payload?.errors,
                            },
                        },
                    }
                }
            }
        },
        updateSubFormAuxiliary: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['digital_sub_name'] &&
                    action?.['payload']?.['auxiliary']
                ) {
                    const curr = action?.payload?.digital_name
                    const currSub = action?.payload?.digital_sub_name
                    const currData = state?.[curr]
                    const currSubData = state?.[curr]?.[currSub]
                    const currSubVal = state?.[curr]?.[currSub]?.['auxiliary']
                    state[action?.payload?.digital_name] = {
                        ...currData,
                        [action?.payload?.digital_sub_name]: {
                            ...currSubData,
                            auxiliary: {
                                ...currSubVal,
                                ...action?.payload?.auxiliary,
                            },
                        },
                    }
                }
            }
        },
        deleteSubFormData: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['digital_sub_name']
                ) {
                    const curr = action?.payload?.digital_name
                    const currSub = action?.payload?.digital_sub_name
                    const currData = state?.[curr]
                    const currSubData = state?.[curr]?.[currSub]
                    state[action?.payload?.digital_name] = {
                        ...currData,
                        [action?.payload?.digital_sub_name]: {
                            ...currSubData,
                            values: {},
                        },
                    }
                }
            }
        },
        deleteSubFormValidity: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['digital_sub_name']
                ) {
                    const curr = action?.payload?.digital_name
                    const currSub = action?.payload?.digital_sub_name
                    const currData = state?.[curr]
                    const currSubData = state?.[curr]?.[currSub]
                    state[action?.payload?.digital_name] = {
                        ...currData,
                        [action?.payload?.digital_sub_name]: {
                            ...currSubData,
                            errors: {},
                        },
                    }
                }
            }
        },
        deleteSubFormAuxiliary: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['digital_sub_name']
                ) {
                    const curr = action?.payload?.digital_name
                    const currSub = action?.payload?.digital_sub_name
                    const currData = state?.[curr]
                    const currSubData = state?.[curr]?.[currSub]
                    state[action?.payload?.digital_name] = {
                        ...currData,
                        [action?.payload?.digital_sub_name]: {
                            ...currSubData,
                            auxiliary: {},
                        },
                    }
                }
            }
        },
        updateFormSystem: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['system']
                ) {
                    state[action.payload.digital_name] = {
                        ...state?.[action.payload.digital_name],
                        system: {
                            ...action?.payload?.system,
                        },
                    }
                }
            }
        },
    },
})

export const selectForms = (state) => state.forms
export const {
    createFormData,
    createFormValidity,
    createFormAuxiliary,
    updateFormData,
    updateFormValidity,
    updateFormAuxiliary,
    deleteFormData,
    deleteFormValidity,
    deleteFormAuxiliary,
    createSubFormData,
    createSubFormValidity,
    createSubFormAuxiliary,
    updateSubFormData,
    updateSubFormValidity,
    updateSubFormAuxiliary,
    deleteSubFormData,
    deleteSubFormValidity,
    deleteSubFormAuxiliary,
    updateFormSystem,
} = formSlice.actions
export default formSlice.reducer
